import { Trans } from '@lingui/react'
import classnames from 'clsx'
import type { VFC } from 'react'

import { shouldShowBuyButton } from 'views/containers/crosssell/CrosssellSliderHorizontal/utils'
import {
  usePageProperties,
  usePublicConfig,
} from 'views/utils/shopAndRuntimeConfigUtils'

type Props = {
  shippingPrice: string
  wid: number
}

const ProductSliderItemShippingPrice: VFC<Props> = ({ shippingPrice, wid }) => {
  const {
    crosssell: { widgets },
  } = usePublicConfig()
  const { experiments } = usePageProperties()

  if (!shouldShowBuyButton(wid, widgets, experiments)) {
    return null
  }

  const priceAsNumber = parseFloat(
    String(shippingPrice).replace(',', '.')
  ).toFixed(2)
  const priceFormatted = `€ ${priceAsNumber.replace('.', ',')}`

  const isShippingPriceFree = (): boolean => {
    const num = Number.parseFloat(
      String(shippingPrice).replaceAll(' ', '').replace(',', '.')
    )
    if (Number.isNaN(num)) {
      return true
    }

    return num === 0
  }

  return (
    <div className="xsellShippingPrice u-text-align--center">
      <div
        className={classnames('u-padding-small--top a-p8', {
          'u-color--positive': isShippingPriceFree(),
          'u-color--grey': !isShippingPriceFree(),
        })}
      >
        {isShippingPriceFree() ? (
          <Trans id="general.label.now.freeShipping" />
        ) : (
          <Trans
            id="general.label.additionalShippingCost"
            values={{ amount: priceFormatted }}
          />
        )}
      </div>
    </div>
  )
}

export default ProductSliderItemShippingPrice
